import { FileInfo } from '@applyboard/crystal-ui';

export interface RbcGicFormTypeV2 {
  id?: string;
  emailAddress: string;
  confirmEmailAddress: string;
  letterOfAcceptanceFile: FileInfo[];
  prefix: string;
  givenName: string;
  surname: string;
  dateOfBirth: string;
  purpose: string;
  employmentStatus: string;
  occupation: string;
  occupationOther: string;
  companyName: string;
  companyPhoneNumber: string;
  phoneNumber: string;
  isMobileNumber: boolean;
  aptOrSuiteResidential: string;
  numberAndStreetNameResidential: string;
  cityResidential: string;
  stateOrProvinceResidential: string;
  countryResidential: string;
  postalCodeResidential: string;
  isSameAsResidentialAddress: boolean;
  aptOrSuiteMailing: string;
  numberAndStreetNameMailing: string;
  cityMailing: string;
  stateOrProvinceMailing: string;
  countryMailing: string;
  postalCodeMailing: string;
  passportNumber: string;
  issuingCountry: string;
  issuingPlaceOrAuthority: string;
  expiryDate: string;
  school: string;
  provinceOfStudy: string;
  expectedArrivalDate: string;
  expectedGraduationMonth: string;
  expectedGraduationYear: string;
  isThirdPartyInvestment: string;
  isCanadianResidentForTax: string;
  isOtherCountryResidentForTax: string;
  canadianTaxProvince: string;
  numOfOtherCountryResidentForTax?: number;
  otherCountryResidentForTaxCountry1: string;
  otherCountryResidentForTaxCountry2: string;
  otherCountryResidentForTaxCountry3: string;
  hasPoliticallyImportantPositions: string;
  politicallyImportantFullName: string;
  politicallyImportantRelationship: string;
  politicallyImportantRole: string;
  sourceOfWealth: Array<string>;
  gicFundSource: Array<string>;
  sourceOfWealthOther: string;
  gicFundSourceOther: string;
  levelOfStudy: string;
  verificationCode?: string;
  gicId?: string;
  studentId?: string;
}

export enum RbcGicEvents {
  PageView = 'RBC GIC Form - Page View',
  StartedForm = 'RBC GIC Form - Started Form - Submission Completed',
  StartedFormSubmissionValidationErrored = 'RBC GIC Form - Started Form - Submission Validation Errored',
  StartedFormSubmissionApiErrored = 'RBC GIC Form - Started Form - Submission API Errored',
  VerifiedForm = 'RBC GIC Form - Verified Form',
  SubmissionErrored = 'RBC GIC Form - Submission Errored',
  SubmissionCompleted = 'RBC GIC Form - Submission Completed',
}
